<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
      <v-tab @change="changetab('Company Type Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        Company Type
      </v-tab>
      <v-tab @change="changetab('Job Type Master')">
        <v-icon left>
          mdi-account
        </v-icon>
        Job Type
      </v-tab>
      <v-tab @change="changetab('Company + Job - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Company + Job
      </v-tab>


       <v-tab @change="changetab('Event + Company Type Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Event + Company
      </v-tab>

      <v-tab @change="changetab('Event + Job Type Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Event + Job
      </v-tab>

      <v-tab-item >
        <companytype></companytype>
      </v-tab-item>
      <v-tab-item>
        <jobtype></jobtype>
      </v-tab-item>
      <v-tab-item style="background-color:#e9e9e9;">
       <companyjobmerge></companyjobmerge>
      </v-tab-item>
       <v-tab-item style="background-color:#e9e9e9;">
       <EventCompanytypemerge></EventCompanytypemerge>
      </v-tab-item>
      <v-tab-item style="background-color:#e9e9e9;">
       <EventJobtypemerge></EventJobtypemerge>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import companytype from '../../../components/companytype'
import jobtype from '../../../components/jobtype'
import companyjobmerge from '../../../components/companyjobmerge.vue'
import EventCompanytypemerge from '../../../components/EventCompanytypemerge.vue'
import EventJobtypemerge from '../../../components/EventJobtypemerge.vue'


export default {
 components: {companytype,jobtype,companyjobmerge,EventCompanytypemerge,EventJobtypemerge},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>